import { ComponentType, useCallback, useState } from 'react'
import type { PopupInfo } from '@/components/organisms/productDetailPopup'
import hoistNonReactStatic from 'hoist-non-react-statics'
import dynamic from 'next/dynamic'

export type ShowProductModal = (productId, sizeId) => void

const ProductDetailPopup = dynamic(
  () => import('@/components/organisms/productDetailPopup'),
  {
    ssr: false
  }
)

export const withProductDetailPopup = (
  WrappedComponent: ComponentType
): ((props) => JSX.Element) => {
  const ComponentWithPopup = (props) => {
    const [popupInfo, setPopupInfo] = useState<PopupInfo>(null)
    const showProductModal: ShowProductModal = useCallback(
      (productId, sizeId) => {
        setPopupInfo({ ...popupInfo, sizeId: sizeId, productId: productId })
      },
      []
    )
    const onDidTapClose = () => setPopupInfo(null)
    return (
      <>
        {popupInfo && (
          <ProductDetailPopup
            productId={popupInfo.productId}
            sizeId={popupInfo.sizeId}
            onDidTapClose={onDidTapClose}
          />
        )}
        <WrappedComponent
          key={WrappedComponent.displayName}
          showProductModal={showProductModal}
          {...props}
        />
      </>
    )
  }
  ComponentWithPopup.displayName = `WithProductDetailPopup(${WrappedComponent.displayName})`

  hoistNonReactStatic(ComponentWithPopup, WrappedComponent)

  return ComponentWithPopup
}
